/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon16Regular = forwardRef('ArrowDRadiusDownLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.25 3c0 2.9-2.35 5.25-5.25 5.25H3.06l3.22-3.22a.75.75 0 1 0-1.06-1.06L1.568 7.62a1.95 1.95 0 0 0 0 2.758L5.22 14.03a.75.75 0 0 0 1.06-1.06L3.06 9.75H8A6.75 6.75 0 0 0 14.75 3v-.25a.75.75 0 0 0-1.5 0V3Z" })));
});
